import { isUrlDev } from '@frontend/utils/tenant';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
	beforeLoad: async ({ location }) => {
		if (!import.meta.env.DEV && !isUrlDev(location.url))
			throw redirect({ to: '/auth/login' });
		throw redirect({
			to: '/home',
			search: (p) => ({ ...p, sectionId: p.sectionId ?? 'NONE' }),
		});
	},
});
